import React, { createContext, useContext, useEffect, useState } from 'react';
import { getRuntimeConfig } from '../config/runtime';

interface SocketContextType {
  socket: WebSocket | null;
  isConnected: boolean;
}

const SocketContext = createContext<SocketContextType>({
  socket: null,
  isConnected: false,
});

export const useSocketContext = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocketContext must be used within SocketProvider');
  }
  return context;
};

interface SocketProviderProps {
  children: React.ReactNode;
}

export const SocketProvider: React.FC<SocketProviderProps> = ({ children }) => {
  const [socket] = useState<WebSocket | null>(null);
  const [isConnected] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Get the already-loaded runtime config (loaded in index.tsx before render)
    const config = getRuntimeConfig();
    
    if (!config) {
      return;
    }
    
    
    // NOTE: WebSocket connection is now handled by WebSocketProvider after authentication
    // Do not connect here - let WebSocketProvider handle it after user logs in
    setIsReady(true);
  }, []);

  // Don't render children until we've determined the mode
  if (!isReady) {
    return <div>Loading...</div>;
  }

  return (
    <SocketContext.Provider value={{ socket, isConnected }}>
      {children}
    </SocketContext.Provider>
  );
};
